import {
  PERCENT_POINTS,
  formatGrouped,
  formatPercentPoints,
  isGroupedUnit,
} from "@/utils/numberlike";
import {
  formatDollarAmount,
  formatDollarFull,
  formatPercentAmount,
} from "../../utils";

// One number as its unit renders it, or null when the value is not a number.
// `usd` abbreviates, `usd_full` shows the whole figure, `amount` stays grouped
// and unrounded (#10835), `grouped` / `grouped_2dp` group with commas at
// their fixed decimals (#12942), `percent` multiplies the stored fraction
// back out, `percent_points` shows the stored percentage itself to two
// decimals (#12500), and a plain number shows its digits. The grid's number
// cells and the table's selection totals (#13976) both read it, so a total
// reads the way the cells it adds up do.
export const formatNumberDisplay = (
  value: unknown,
  unit: string | null | undefined
): string | null => {
  const n = typeof value === "number" ? value : parseFloat(String(value));
  if (!Number.isFinite(n)) return null;
  if (unit === "usd") return formatDollarAmount(n);
  if (unit === "usd_full") return formatDollarFull(n);
  if (unit === "amount") {
    return n.toLocaleString("en-US", { maximumFractionDigits: 20 });
  }
  if (isGroupedUnit(unit)) return formatGrouped(n, unit);
  if (unit === "percent") {
    return formatPercentAmount(Number((n * 100).toFixed(6)));
  }
  if (unit === PERCENT_POINTS) return formatPercentPoints(n);
  return Number.isInteger(n) ? String(n) : String(value);
};
